import React, { useEffect, useState } from 'react';
import Container from "react-bootstrap/Container";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Image from 'react-bootstrap/Image';
import Carousel from 'react-bootstrap/Carousel';

import imgCostAndEnv from '../../assets/img/home/icon_cost-and-environment_v2.svg';
import imgInfoConsult from '../../assets/img/home/icon_information_consultants_v1.svg';
import imgRenovation from '../../assets/img/home/icon_renovation-modernisation_v2.3.svg';
import imgFreeAndNeutral from '../../assets/img/home/icon_free-and-neutral_v2.svg';
import Button from "react-bootstrap/Button";
import {Link, useNavigate} from "react-router-dom";
import house_example from "../../assets/img/home/house_example.jpg";

import Partners from "../home/Partners";
import HowTo from "../home/HowTo";



import { useDispatch, useSelector } from 'react-redux';
import { addressSelect } from "../../reducers/addressActions";
import { dataLoadFirstQuery } from "../../reducers/dataActions";
import { useLocation } from 'react-router-dom';
import {addressSearch} from "../../reducers/addressActions";




// Trying to implement better usability with this quick hack so
import {selectDataLoading} from "../../reducers/dataSelectors";

export default function Home() {

    const [egid, setEgid] = useState(null)
    const [lookupError, setLookupError] = useState(null)
    const [base, setBase] = useState(null)
    const [server, setServer] = useState(null) 
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const location = useLocation();
    const selectedAddress = useSelector((state) => state.address.list);
    const loading = useSelector(selectDataLoading);
    const isLoading = loading.first || loading.second || loading.third || loading.fourth;
    const isDataLoaded = useSelector((state) => state.address.selected);

    

    useEffect(() => {
        const getEgidFromSearch = (search) => {
            const params = new URLSearchParams(search);
            return params.get('egid');
        };
        const getBaseFromSearch = (search) => {
            const params = new URLSearchParams(search);
            return params.get('base');
        };

        const getServerFromSearch = (search) => {
            const params = new URLSearchParams(search);
            return params.get('server');
        }

        const egidFromURL = getEgidFromSearch(location.search)
        const baseFromURL = getBaseFromSearch(location.search)
        const serverFromURL = getServerFromSearch(location.search)
        setEgid(egidFromURL ? (egidFromURL.includes('_') ? egidFromURL : `${egidFromURL}_0`) : null)
        setBase(baseFromURL)
        setServer(serverFromURL)
        
        if (egidFromURL) {
            dispatch(addressSelect(undefined))
            setLookupError(null)
            fetchData(egidFromURL).then((label) => {
                dispatch(addressSearch(label))
            }).catch((error) => setLookupError(error.message))

        }

    }, [location, dispatch]);

    useEffect(() => {
        if (selectedAddress && selectedAddress.length > 0 && egid) {
            const matchingAddress = selectedAddress.find(address => String(address.attrs.featureId) === egid)
            if (!matchingAddress) return;
            dispatch(addressSelect(matchingAddress))
            dispatch(dataLoadFirstQuery({ server, base }))
        }
    }, [selectedAddress, dispatch, egid, server, base])


    useEffect(() => {
        if (isDataLoaded && isLoading) {
            navigate('/dateneingabe');
        }
    }, [isDataLoaded, isLoading, navigate]);
    
    const fetchData = async (egid) => {
        const featureId = egid.includes('_') ? egid : `${egid}_0`;
        const response = await fetch(
            `https://api3.geo.admin.ch/rest/services/api/MapServer/ch.bfs.gebaeude_wohnungs_register/${encodeURIComponent(featureId)}?sr=21781`
        );
        if (!response.ok) {
            throw new Error(`Gebäude konnte nicht geladen werden (HTTP ${response.status}).`);
        }
        const data = await response.json();
        const attrs = data.feature?.attributes;
        if (!attrs?.strname_deinr || !attrs?.dplz4) {
            throw new Error('Keine Adresse für diese EGID gefunden.');
        }
        return `${attrs.strname_deinr} ${attrs.dplz4} ${attrs.dplzname || ''}`;
    }
    return <div>
        <Container>
            {lookupError && <div role="alert" className="alert alert-danger">{lookupError}</div>}

            <Row className={'mt-5'}>
                <Col>
                    <div className={'d-flex justify-content-center mb-3'}>
                        <h3>Das bieten wir:</h3>
                    </div>

                    <Carousel variant={"dark"} style={{height: '200px'}}>
                        <Carousel.Item>
                            <Image width={'100%'}
                                   height={120} src={imgCostAndEnv}></Image>
                            <Carousel.Caption style={{'position': 'relative', 'right': '50%', 'left': 0}}>
                                Kosten- und Umwelt-Analyse zu deinem Haus
                            </Carousel.Caption>
                        </Carousel.Item>
                        <Carousel.Item>
                            <Image width={'100%'}
                                   height={120}
                                   src={imgRenovation}></Image>
                            <Carousel.Caption style={{'position': 'relative', 'right': '50%', 'left': 0}}>
                                Vorschläge zu Renovation und Modernisierung
                            </Carousel.Caption>
                        </Carousel.Item>
                        <Carousel.Item>
                            <Image width={'100%'}
                                   height={120}
                                   src={imgInfoConsult}></Image>
                            <Carousel.Caption style={{'position': 'relative', 'right': '50%', 'left': 0}}>
                                Infos zu Fachberatern in deiner Umgebung
                            </Carousel.Caption>
                        </Carousel.Item>
                        <Carousel.Item>
                            <Image width={'100%'}
                                   height={120}
                                   src={imgFreeAndNeutral}></Image>
                            <Carousel.Caption style={{'position': 'relative', 'right': '50%', 'left': 0}}>
                                Kostenlos, neutral und ohne Werbung
                            </Carousel.Caption>
                        </Carousel.Item>
                    </Carousel>

                    <div className={'d-flex justify-content-center mt-5 mb-5'}>
                    <Link className={'nav-link'} to="/auswahl">
                        <Button variant={"dark"} size={'lg'}>Jetzt mit Gebäudeauswahl starten</Button>
                    </Link>
                    </div>

                </Col>
                <Col xs={"auto"} style={{height: '450px'}} className={'justify-content-end d-flex'}>
                    <Image height={'100%'} src={house_example} />

                    {/*<Carousel variant={"dark"} style={{height: '350px'}} >*/}
                    {/*    <Carousel.Item>*/}
                    {/*    </Carousel.Item>*/}
                    {/*    <Carousel.Item>*/}
                    {/*        <Image height={300} src={situation_example} />*/}
                    {/*</Carousel.Item>*/}
                    {/*</Carousel>*/}
                </Col>

                {/*<Col xs={12} className={'mt-3'}>*/}
                {/*    <h4>Mithilfe dieser Daten kannst du das Tool optimal nutzen</h4>*/}
                {/*    <ul>*/}
                {/*        <li>Wohnfläche(n), Anzahl Bewohner</li>*/}
                {/*        <li>Strom- und Heizkostenabrechnung</li>*/}
                {/*        <li>Steuersatz (für die Finanzoptimierung)</li>*/}
                {/*        <li>Erfolgte Renovationen und Neuanschaffungen</li>*/}
                {/*        <li>Grösse/Leistung einer allfälligen Solaranlage</li>*/}
                {/*    </ul>*/}
                {/*</Col>*/}
            </Row>

            <HowTo />

            <Partners />

        </Container>
    </div>;
}
